import { useEffect, useState } from "react";
import { ArticleClassCode } from "../../../core/services/dataBean/contabilidad/ArticleClassCode.Entity";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _single } from "../../../core/services/dataBean/EntityCatalog";

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}
export const SelectGoodTypeConstans = ({ idSelector, onChange, label }: Props) => {

    const articleClassCode = new ArticleClassCode("QuickDataERPCore", "com.quickdataerp.bean.supplier.ArticleClassCode");
    const { instance, lista, setLista, bean, setBean } = useDataBean(articleClassCode);

    const [id, setID] = useState<number>();

    useEffect(() => {
        getGoodTypesConstants();
    }, [])

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector);
        }
    }, [idSelector])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    };

    const getGoodTypesConstants = () => {
        let tmp = _single.getSessionItem('goodTypes');
        if (tmp) {
            setLista(JSON.parse(tmp));

        } else {
            instance.getGoodTypesConstants(null).then(
                (resp: any) => {
                    lista(resp);
                    _single.setSessionItem('goodTypes', JSON.stringify(resp));
                }
            ).catch(err => console.error(err))

        }
    }

    return (
        <>
            <label>{label ? label : 'Tipo de Activo'}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null
                setValue(value)
            }}>
                <option value={""} >...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.Value} value={item.DataBeanProperties.Value} >{item.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}